import { Box, TextField, MenuItem, useTheme, Select } from '@mui/material';
import {
  CcfTextField,
  CcfUpArrowIcon,
  useTranslator,
} from '@nice-ccf/ui-controls';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectDropDownQueryValue,
  fetchAgentContactGroup,
} from '../+state/ccf-directory.slice';
import classes from '../ccf-directory.module.scss';

/**
 * Component to be used for ccf directoy select
 * @example - <CcfDirectorySelect />
 * @returns
 */
export const CcfDirectorySelect = () => {
  const dispatch = useDispatch();
  const selectedOption = useSelector(selectDropDownQueryValue);
  const theme = useTheme();
  const type = theme.palette.mode;
  const [translate] = useTranslator();

  /**
   * Function to dispatch an action to fetch agent contact group
   * @param e -  React.ChangeEvent
   * @example - dispatchQueryUpdateAction(e)
   */
  function dispatchQueryUpdateAction(
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) {
    dispatch(fetchAgentContactGroup(e.target.value));
  }

  return (
    <Box bgcolor="background.level1" p={1} pb={2}>
      <Select
        id="selected option"
        size="small"
        style={{
          background: type === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'white',
          border: '1px solid #c4c4c4',
        }}
        onChange={(e: any) => dispatchQueryUpdateAction(e)}
        // InputProps={{
        //   onChange: dispatchQueryUpdateAction,
        // }}
        value={selectedOption}
        variant="outlined"
        fullWidth
        IconComponent={() => (
          <CcfUpArrowIcon className={classes.arrowIconForDropdown} />
        )}
      >
        <MenuItem value="my_team">{translate('myTeam')}</MenuItem>
        <MenuItem value="favourites">{translate('favorites')}</MenuItem>
        <MenuItem value="people" disabled>
          {'People'}
        </MenuItem>
      </Select>
    </Box>
  );
};
